"use client";

import NextImage from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Thumbs, EffectFade } from "swiper/modules";

import type { SectionsColorVariationCarousel } from "@/types";

import { ColorVariationCarouselReturnVariantProps } from "./color-variation-carousel.variants";
import { useColorVariationCarouselSwiper } from "./use-color-variation-carousel-swiper";

export interface ColorVariationCarouselSwiperProps {
  list: SectionsColorVariationCarousel["list"];
  styles: ColorVariationCarouselReturnVariantProps;
}

function ColorVariationCarouselSwiper({
  list,
  styles,
}: ColorVariationCarouselSwiperProps) {
  const { thumbsSwiper, setThumbsSwiper } = useColorVariationCarouselSwiper();

  return (
    <div>
      <Swiper
        effect="fade"
        thumbs={{ swiper: thumbsSwiper }}
        modules={[EffectFade, Thumbs]}
        simulateTouch
        slidesPerView={1}
        spaceBetween={0}
        className={styles.swiper()}
      >
        {list.map((item) => (
          <SwiperSlide
            className="!w-full"
            key={`color-variation-carousel-item-${item.id}-${item.image.id}`}
          >
            <NextImage
              alt={item.image.alternativeText || "image"}
              width={1008}
              height={400}
              src={item.image.url}
              className={styles.image()}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={12}
        slidesPerView={8}
        modules={[Thumbs]}
        className={styles.thumbs()}
      >
        {list.map((item) => (
          <SwiperSlide
            className="!w-6.5 !h-6.5 p-0.25"
            key={`color-variation-carousel-item-${item.id}`}
          >
            <span
              className={styles.thumbSlide()}
              style={{
                backgroundColor: item.color,
                outlineColor: item.color,
              }}
            >
              1
            </span>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default ColorVariationCarouselSwiper;
